export class ChainedSchema {
    parentSchema;
    constructor(parentSchema) {
        this.parentSchema = parentSchema;
    }
    serializer(...args) {
        return this.parentSchema.serializer(...args);
    }
    deserializer(...args) {
        return this.parentSchema.deserializer(...args);
    }
    get jsonname() {
        return this.parentSchema.jsonname;
    }
    get providesDefault() {
        return this.parentSchema.providesDefault || false;
    }
    shouldDisgardOldValue(context) {
        if (!this.parentSchema.shouldDisgardOldValue)
            return false;
        return this.parentSchema.shouldDisgardOldValue(context);
    }
}
